import * as React from 'react';
import './alert.css';

export interface AlertProps {}

const Alert: React.StatelessComponent<AlertProps> = ({ children }) => <div className="alert">{children}</div>;

export default Alert;
